import { ICON__chevron_down } from '@/assets/icons_fa';
import { UI_PRIMITIVE__dropdown_menu } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu';
import { UI_PRIMITIVE__dropdown_menu_content } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu_content';
import { UI_PRIMITIVE__dropdown_menu_item } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu_item';
import { UI_PRIMITIVE__dropdown_menu_trigger } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu_trigger';
import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { LOCAL__ui_set_string } from '@/state/ui/_base/LOCAL__ui_set_string';
import { cn } from '@/utils/utils_client';
import { ENUM__image_compare_mode } from '../ENUM__image_compare_mode';

export function DROPDOWN__image_compare_mode() {
  const dispatch = use_dispatch();

  /*
   * STORE
   */

  const { grid2d_image_compare__mode } = use_slice_ui(['grid2d_image_compare__mode']);

  /*
   * STATE
   */

  /*
   * EVENTS
   */
  function on_item_selected(value: ENUM__image_compare_mode) {
    if (value == grid2d_image_compare__mode) return;

    dispatch(LOCAL__ui_set_string({ key: 'grid2d_image_compare__mode', value, valid_values: Object.values(ENUM__image_compare_mode) }));
  }

  /*
   *
   */

  function render_item(value: ENUM__image_compare_mode) {
    return (
      <UI_PRIMITIVE__dropdown_menu_item
        key={`field_store_interaction_${value}`}
        values_selected={[grid2d_image_compare__mode]}
        class_name_hovered_selected="bg-component-item-selected"
        className={cn('px-2 py-0.5 cursor-pointer text-xs bg-component text-component-item-foreground')}
        value={value}
        on_item_selected={() => void on_item_selected(value)}
      >
        {value}
      </UI_PRIMITIVE__dropdown_menu_item>
    );
  }

  /*
   * HTML
   */

  return (
    <>
      <UI_PRIMITIVE__dropdown_menu modal={false}>
        <UI_PRIMITIVE__dropdown_menu_trigger asChild>
          <UI_PRIMITIVE__button className={` relative h-6  text-component-foreground text-xs w-full`} variant="outline-on-component">
            Compare mode: {grid2d_image_compare__mode}
            <ICON__chevron_down className="!w-3 !h-3 absolute right-3 top-3.3" />
          </UI_PRIMITIVE__button>
        </UI_PRIMITIVE__dropdown_menu_trigger>

        <UI_PRIMITIVE__dropdown_menu_content
          className="w-[--radix-dropdown-menu-trigger-width] rounded-lg dark:bg-component dark:border-component-border p-0"
          align="start"
          side="bottom"
          sideOffset={4}
        >
          {Object.values(ENUM__image_compare_mode).map(render_item)}
        </UI_PRIMITIVE__dropdown_menu_content>
      </UI_PRIMITIVE__dropdown_menu>
    </>
  );
}
